<template>
  <div class="admin-vault-filter-container" v-click-outside="clickOutside">
    <AdminButton border @click="show = !show">
      <img src="/images/icons/filter.svg" />
      Filter
    </AdminButton>
    <div class="admin-vault-filter-wrapper" v-show="show">
      <div class="admin-vault-filter-dropdown">
        <div
          class="admin-vault-filter-dropdown-item"
          v-for="(item, key) in filters"
          :key="key"
        >
          <b>{{ capitalizeFirstLetter(key) }}</b>
          <div
            class="admin-vault-filter-dropdown-children"
            v-for="(child, i) in item"
            :key="i"
          >
            <input
              type="checkbox"
              :ref="child"
              @change="toogleCheck(key, child, $event)"
            />
            <span style="text-transform: uppercase" v-if="key == 'token'">
              {{ child.symbol }}
            </span>
            <span v-else>
              {{ formattingType(child) }}
            </span>
          </div>
        </div>
      </div>
      <AdminButton border block @click="clear"> Clear </AdminButton>
    </div>
  </div>
</template>

<script>
import AdminButton from "../Button/AdminButton.vue";

export default {
  props: {
    value: {
      type: Object,
    },
    all: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AdminButton,
  },
  data() {
    return {
      show: false,
      filters: {},
    };
  },
  mounted() {
    this.$store
      .dispatch("API", {
        url: "/api/admin/options",
      })
      .then((result) => {
        const token = result.token.map((a) => {
          return { id: a.id, symbol: a.symbol.toUpperCase() };
        });
        this.filters.token = token;
        if (this.all) {
          this.filters = {
            // token: ["weth", "wbtc"],
            chain: ["ETH", "BSC"],
            token: token,
            type: ["put_selling", "covered_call"],
            period: ["daily", "weekly","biweekly", "monthly"],
            state: ["live", "mature", "archived"],
          };
        } else {
          this.filters = {
            chain: ["ETH", "BSC"],
            token: token,
            type: ["put_selling", "covered_call"],
            period: ["daily", "weekly","biweekly", "monthly"],
            state: ["live", "archived"],
          };
        }
      });
  },
  methods: {
    clickOutside() {
      this.show = false;
    },
    toogleCheck(key, child, event) {
      let childKey;
      if (key == "token") childKey = child.id;
      else childKey = child;
      const currentKey = this.value[key];
      this.$emit("input", {
        ...this.value,
        [key]: {
          ...currentKey,
          [childKey]: event.target.checked,
        },
      });
    },
    clear() {
      for (const key in this.$refs) {
        const element = this.$refs[key];
        element[0].checked = false;
      }
      this.$emit("input", {
        search: null,
        chain: [],
        token: [],
        type: [],
        period: [],
        state: [],
      });
    },
  },
};
</script>


<style scoped>
.admin-vault-filter-container {
  position: relative;
}

.admin-vault-filter-wrapper {
  margin-top: 10px;
  padding: 8px;
  background-color: white;
  border: 1px solid rgb(185, 185, 185);
  border-radius: 8px;
  position: absolute;
  z-index: 1;
  width: 100%;
}

.admin-vault-filter-dropdown-item {
  margin-bottom: 8px;
}
</style>
